"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var banner = _interopRequireWildcard(require("@/api/banner-store"));
var _BannerDialog = _interopRequireDefault(require("./components/BannerDialog"));
var _format = require("@/utils/format");
var _date = require("@/utils/date");
var _utils = require("@/utils");
var _StoreDialog = _interopRequireDefault(require("@/views/store/components/StoreDialog"));
var _vuex = require("vuex");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default,
    BannerDialog: _BannerDialog.default,
    StoreDialog: _StoreDialog.default
  },
  data: function data() {
    return {
      listLoading: false,
      total: 0,
      baseUrl: process.env.VUE_APP_BASE_API,
      baseUrlMedia: process.env.VUE_APP_BASE_URL_MEDIA,
      listQuery: {
        page: 1,
        limit: 10,
        search: "",
        isBlock: null,
        areaId: this.$store.state.user.info.area ? this.$store.state.user.info.area.id : undefined
      },
      tableData: []
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapState)({
    areas: function areas(state) {
      return state.area.list;
    }
  })),
  created: function created() {
    this.getTableData();
    this.$store.dispatch("area/fetchList");
  },
  methods: {
    viewStore: function viewStore(store) {
      this.$refs["store-dialog"].handleEdit(store);
    },
    stripHtml: function stripHtml(s) {
      return (0, _utils.stripHtml)(s);
    },
    formatDateTime: function formatDateTime(n) {
      return (0, _date.formatDateTime)(n);
    },
    handleEdit: function handleEdit(row) {
      this.$refs["dialog"].handleUpdate(row);
    },
    handleDelete: function handleDelete(row) {
      var _this = this;
      this.$confirm("Banner sẽ bị xóa. Tiếp tục?", "Warning", {
        confirmButtonText: "Xóa",
        cancelButtonText: "Đóng",
        type: "warning"
      }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return banner.remove(row.id);
            case 2:
              _this.getTableData();
              _this.$message({
                type: "success",
                message: "Đã xóa banner"
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })));
    },
    handleAdd: function handleAdd() {
      this.$refs["dialog"].handleCreate();
    },
    handleImgError: function handleImgError(event) {
      event.currentTarget.src = require("@/assets/images/avatar_default.svg");
    },
    handleUnBlock: function handleUnBlock(row) {
      var _this2 = this;
      this.$confirm("Banner này sẽ được hiển thị, bạn có muốn tiếp tục?", "Cảnh báo", {
        confirmButtonText: "OK",
        cancelButtonText: "Đóng",
        type: "warning"
      }).then(function () {
        var data = {
          bannerStore: {
            isShow: true
          }
        };
        banner.update(row.id, data).then(function () {
          row.isShow = true;
          _this2.$message({
            type: "success",
            message: "Thành công"
          });
        });
      });
    },
    handleBlock: function handleBlock(row) {
      var _this3 = this;
      this.$confirm("Banner này sẽ bị ẩn, bạn có muốn tiếp tục?", "Cảnh báo", {
        confirmButtonText: "OK",
        cancelButtonText: "Đóng",
        type: "warning"
      }).then(function () {
        var data = {
          bannerStore: {
            isShow: false
          }
        };
        banner.update(row.id, data).then(function () {
          row.isShow = false;
          _this3.$message({
            type: "success",
            message: "Thành công"
          });
        });
      });
    },
    getTableData: function getTableData() {
      var _this4 = this;
      this.listLoading = true;
      banner.findAll(this.listQuery).then(function (res) {
        _this4.tableData = res.data.data;
        _this4.total = res.data.total;
      }).finally(function () {
        _this4.listLoading = false;
      });
    }
  }
};